var map = {
	"./Geva Hason - Daddy Geva Ft.mp3": 5688,
	"./Geva Hason - Funky transition.wav": 3643,
	"./Geva Hason - Sab kuch milega.wav": 2071,
	"./Geva Hason - גבע חסון - תגידו.mp3": 6650,
	"./Geva Hason - שיר ערש.mp3": 7796,
	"./גבע חסון - לא.mp3": 6784,
	"./גבע חסון - שר מלחמה.mp3": 7188,
	"./גבע חסון ודנה חרמון - עיניים עצומות.mp3": 2503,
	"./שיר עזר - את לא פה.mp3": 3767
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5820;